import { Wrench } from "lucide-react";

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="text-center max-w-lg">
        {/* Logo */}
        <img 
          src="https://customer-assets.emergentagent.com/job_5a4239fb-4bc2-4826-87e7-5a8922edf632/artifacts/sxfp077y_logo.jpg" 
          alt="ACICAR Logo" 
          className="h-24 mx-auto mb-8"
        />
        
        {/* Icon */}
        <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
          <Wrench className="w-10 h-10 text-white" />
        </div>
        
        {/* Title */}
        <h1 className="text-4xl font-bold text-white mb-4">
          Site en maintenance
        </h1>
        
        {/* Message */}
        <p className="text-gray-400 text-lg mb-8">
          Nous effectuons actuellement des améliorations sur notre site. 
          Nous serons de retour très bientôt !
        </p>
        
        {/* Contact */}
        <div className="bg-gray-800 rounded-xl p-6 inline-block">
          <p className="text-gray-300 mb-2">Pour nous contacter :</p>
          <a 
            href="tel:0646634968" 
            className="text-yellow-500 text-2xl font-bold hover:text-yellow-400 transition-colors"
          >
            06 46 63 49 68
          </a>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
